import { render, staticRenderFns } from "./PurchasedProductInputSearch.vue?vue&type=template&id=3967f4a4&scoped=true&"
import script from "./PurchasedProductInputSearch.vue?vue&type=script&lang=js&"
export * from "./PurchasedProductInputSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967f4a4",
  null
  
)

export default component.exports